import { Calendar } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';

document.addEventListener('turbolinks:load', function() {
  var calendarEl = document.getElementById('schedule-lesson-calendar');
  var timeZone;

  function mobileCheck() {
    if (window.innerWidth >= 768 ) {
      return false;
    } else {
      return true;
    }
  };

  var mobileDeviceCheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  var popupEnabled = function() {
    return false;
  }

  if (calendarEl) {
    import(/* webpackChunkName: "moment" */ 'moment').then((momentModule) => {
      import(/* webpackChunkName: "moment-timezone" */ 'moment-timezone').then((momentTimezone) => {

        const moment = momentModule.default;

        // Set moment locale from page language for translated day/month names
        var pageLocale = (document.documentElement.lang || 'en').toLowerCase();
        var fcLocale = null;
        if (pageLocale !== 'en') {
          try { require('moment/locale/' + pageLocale); moment.locale(pageLocale); } catch(e) {}
          try { var fcModule = require('@fullcalendar/core/locales/' + pageLocale); fcLocale = fcModule.default || fcModule; } catch(e) {}
        }

        var calendarType = calendarEl.dataset.calendarType;
        var calendarStep = calendarEl.dataset.calendarStep;
        var lessonsCount = parseInt(calendarEl.dataset.lessonsCount);

        var remainingLessons = lessonsCount;
        var lessonDuration;
        var defaultLessonDuration = 60; // 60 minutes
        var firstDay;
        var now;
        var businessHours;
        var slotTimes;
        var recurringBookingEnabled = true;
        var lessonTimes = [];
        var eventIds = [];

        var popupEl;
        var modalEl = '#schedule-modal';
        var selectedEvents = {};
        var adjacentEvents = {};
        var confirmBtn = document.getElementById("confirm-booking-btn");

        if (calendarEl.dataset.lessonTimes != 'undefined') {
          lessonTimes = JSON.parse(calendarEl.dataset.lessonTimes);
        }

        if (calendarEl.dataset.eventIds != 'undefined') {
          eventIds = JSON.parse(calendarEl.dataset.eventIds);
        }

        if (calendarEl.dataset.events != 'undefined') {
          selectedEvents = JSON.parse(calendarEl.dataset.events);
        }
        if (calendarEl.dataset.adjacentEvents != 'undefined') {
          adjacentEvents = JSON.parse(calendarEl.dataset.adjacentEvents);
        }

        var isMidnight = function(event) {
          if ((event != null) && (event != undefined)) {
            var dt = momentTimezone.tz(event.extendedProps.start_datetime, timeZone);
            return dt.hours() === 0 && dt.minutes() === 0 && dt.seconds()=== 0;
          } else {
            return false;
          }
        }

        var setupPopover = function(el, title, content) {
          $(el).popover({
            title: '',
            placement: 'top',
            html: true,
            trigger: 'manual',
            animation: false,
            container: 'body',
            content: content
          });
        };

        var buildPopoverContent = function(selectedEvent) {
          var adjacentEvent = findAdjacentEvent(selectedEvent.id);
          var previousEvent = findPreviousEvent(selectedEvent.id);
          var adjacentEventId = findAdjacentEventId(selectedEvent.id);
          var eventStart;
          var eventEnd;

          if ((adjacentEvent != null) && !isMidnight(adjacentEvent) && (selectedEvents[adjacentEventId] === undefined)) {
            eventStart = selectedEvent.extendedProps.start_datetime;
            eventEnd = adjacentEvent.extendedProps.end_datetime;
          } else if (previousEvent != null) {
            eventStart = previousEvent.extendedProps.start_datetime;
            eventEnd = selectedEvent.extendedProps.end_datetime;
          } else {
            eventStart = selectedEvent.extendedProps.start_datetime;
            eventEnd = selectedEvent.extendedProps.end_datetime;
          }

          return `<p><strong>${I18n.t('javascript.schedule.date')}</strong> ${momentTimezone.tz(eventStart, timeZone).format('ddd, MMM D, Y')}</p><p><strong>${I18n.t('javascript.schedule.time')}</strong> ${momentTimezone.tz(eventStart, timeZone).format('hh:mm a')} - ${momentTimezone.tz(eventEnd, timeZone).subtract(5, 'minutes').format('hh:mm a')}</p>`;

        }

        var confirmBtnContainer = document.getElementById("confirm-booking");

        if (calendarEl.dataset.timezone === undefined || calendarEl.dataset.timezone === null || calendarEl.dataset.timezone === 'undefined') {
          timeZone = jstz.determine().name();
        } else {
          timeZone = calendarEl.dataset.timezone;
        }

        if (calendarEl.dataset.lessonDuration === undefined || calendarEl.dataset.lessonDuration === null || calendarEl.dataset.lessonDuration === 'undefined') {
          lessonDuration = defaultLessonDuration;
        } else {
          lessonDuration = parseInt(calendarEl.dataset.lessonDuration);
        }

        if (calendarEl.dataset.firstDay === undefined || calendarEl.dataset.firstDay === null || calendarEl.dataset.firstDay === 'undefined') {
          var firstDay = momentTimezone.tz(jstz.determine().name()).add(1, 'day').day();
        } else {
          var firstDay = calendarEl.dataset.firstDay;
        }

        if (calendarEl.dataset.now === undefined || calendarEl.dataset.now === null || calendarEl.dataset.now === 'undefined') {
          var now = momentTimezone.tz(jstz.determine().name()).add(1, 'day').toISOString();
        } else {
          var now = calendarEl.dataset.now;
        }

        var findAdjacentEvent = function(eventId) {
          var adjacentEventId = parseInt(eventId) + 1800;
          return calendar.getEventById(adjacentEventId);
        }

        var findPreviousEvent = function(eventId) {
          var previousEventId = parseInt(eventId) - 1800;
          return calendar.getEventById(previousEventId);
        }

        var findPreviousEventId = function(eventId) {
          var previousEventId = parseInt(eventId) - 1800;
          var previousEvent = calendar.getEventById(previousEventId);
          if (previousEvent != undefined) {
            return previousEvent.id;
          } else {
            return undefined;
          }
        }

        var findAdjacentEventId = function(eventId) {
          var adjacentEventId = parseInt(eventId) + 1800;
          var adjacentEvent = calendar.getEventById(adjacentEventId);
          if (adjacentEvent != undefined) {
            return adjacentEvent.id;
          } else {
            return undefined;
          }
        }

        var hideSubmitButton = function() {
          confirmBtnContainer.classList.add('d-none');
        }

        var showSubmitButton = function() {
          confirmBtnContainer.classList.remove('d-none');
        }

        var disableSubmitButton = function() {
          hideSubmitButton();
          confirmBtn.disabled = true;
        }

        var enableSubmitButton = function() {
          showSubmitButton();
          confirmBtn.disabled = false;
        }

        var displayRecurringAvailability = function() {
          return (eventIds.length == 0) && (lessonsCount > 1) && recurringBookingEnabled;
        }

        var updateLessonsCount = function() {
          var eventsLength = Object.keys(selectedEvents).length;
          remainingLessons = lessonsCount - eventsLength;

          var remainingLessonsEl = document.getElementsByClassName('remaining-lessons');

          for (var el of remainingLessonsEl) {
            el.innerHTML = ` ${remainingLessons}`;
          }


          if (eventsLength == 0) {
            disableSubmitButton();
          }
        }

        var addLesson = function(event, adjacentEvent, updateLessonList = true) {
          if (adjacentEvent != null) {
            selectedEvents[event.id] = [event, adjacentEvent, adjacentEvent.id];
            adjacentEvents[adjacentEvent.id] = adjacentEvent;
          } else {
            selectedEvents[event.id] = [event];
          }

          if (updateLessonList) {
            let container = document.getElementById('selected-lessons');
            let div = document.createElement('div');
            div.id = `${event.id}`;
            div.innerHTML = `<span class="d-inline-block">${momentTimezone.tz(event.extendedProps.start_datetime, timeZone).format('MMMM D (ddd), h:mm A')}</span> <a id="trash-${event.id}" class="float-right" data-id="${event.id}" href="javascript:void(0)"> <i class="ti-trash"></i></a>`;

            var lessonsSelectedTitle = document.getElementById('selected-lessons-title');
            if ((Object.keys(selectedEvents).length === 1) && (!lessonsSelectedTitle.length)) {
              lessonsSelectedTitle.classList.remove('d-none');
            }
            container.appendChild(div);
          }
        }

        var deleteLesson = function(eventId) {
          if (selectedEvents[eventId] != undefined) {
            var selectedEventPair = selectedEvents[eventId];
            var selectedEvent = calendar.getEventById(eventId) || selectedEventPair[0];
            var adjacentEventId = selectedEventPair[2];

            if (adjacentEventId != undefined) {
              var adjacentEvent = calendar.getEventById(adjacentEventId) || selectedEventPair[1];
            }

            if (((selectedEvent.extendedProps.event_type != 'booked') &&
              selectedEvent.extendedProps.event_type != 'unavailable') &&
              (typeof selectedEvent.setProp === 'function')) {
              if (lessonDuration === defaultLessonDuration) {
                setTimeout(function() {
                  selectedEvent.setProp('backgroundColor', '#1ABC9C');
                  selectedEvent.setProp('classNames', ['']);
                  selectedEvent.setProp('title', '');
                }, 100);

                setTimeout(function() {
                  adjacentEvent.setProp('backgroundColor', '#1ABC9C');
                  adjacentEvent.setProp('classNames', ['']);
                  adjacentEvent.setProp('title', '');
                }, 100);
              } else {
                setTimeout(function() {
                  selectedEvent.setProp('backgroundColor', '#1ABC9C');
                  selectedEvent.setProp('classNames', ['']);
                  selectedEvent.setProp('title', '');
                }, 100);
              }
            }

            delete selectedEvents[eventId];
            if ((adjacentEvent != null) && (adjacentEventId != undefined)) {
              delete adjacentEvents[adjacentEventId];
            }

            if (eventIds.includes(eventId)) {
              let index = eventIds.indexOf(eventId);
              eventIds.splice(index, 1);
              lessonTimes.splice(index, 1);
            }
          }

          let remove = document.getElementById(eventId);

          if (remove != null) {
            let parentNode = remove.parentNode;
            parentNode.removeChild(remove);
          }
        }

        var updateStartTimes = function() {
          let selectedEventIds = Object.keys(selectedEvents);
          let startTimes = Object.values(selectedEvents).map(x => momentTimezone.tz(x[0].extendedProps.start_datetime, timeZone).toISOString());

          // Dedup lesson times
          startTimes = Array.from(new Set(startTimes));
          selectedEventIds = Array.from(new Set(selectedEventIds));

          document.getElementById('schedule_lesson_form_start_times').value = JSON.stringify(startTimes);
          document.getElementById('schedule_lesson_form_event_ids').value = JSON.stringify(selectedEventIds);
          document.getElementById('schedule_lesson_form_events').value = JSON.stringify(selectedEvents);
          document.getElementById('schedule_lesson_form_adjacent_events').value = JSON.stringify(adjacentEvents);
        }

        var trashButton = document.getElementById('selected-lessons');
        trashButton.addEventListener('click', (e) => {
          if(e.target.className == 'ti-trash') {
            var eventId = e.target.parentNode.dataset.id;
            deleteLesson(eventId);
            updateLessonsCount();
            updateStartTimes();
          }
        });

        var highlightSelectedEvent = function(selectedEvent) {
          // hacky way to get event to set props
          // https://github.com/fullcalendar/fullcalendar/issues/5916
          setTimeout(function() {
            selectedEvent.setProp('backgroundColor', '#3D4752');
            selectedEvent.setProp('classNames', ['selected']);
          });
        }

        var calendar = new Calendar(calendarEl, {
          plugins: [ timeGridPlugin ],
          events: function(info, successCallback, failureCallback) {
            let eventsUrl = '/schedule/' + calendarEl.dataset.id + `?calendar_type=${calendarType}&step=${calendarStep}&start=${info.start}&end=${info.end}`;

            if (timeZone != undefined && timeZone != 'local') {
              eventsUrl = encodeURI(`${eventsUrl}&time_zone=${encodeURIComponent(timeZone)}`);
            }

            fetch(eventsUrl, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' }
            }).then(response => response.json()).then(data => {
              businessHours = data.business_hours;
              slotTimes = data.slot_times;
              successCallback(data.events)
            }).catch((error) => {
              console.error('Error:', error);
              failureCallback(error);
            });
          },
          eventSourceSuccess: function(content, xhr) {
            calendar.scrollToTime(slotTimes.min_time);

            return content.eventArray;
          },

          /* Create new view */
          views: {
            newView: {
              /* Your responsive view */
              type: 'timeGridWeek',
              duration: { days: 5 },
              slotLabelFormat: {
                hour: 'numeric',
                minute: '2-digit',
                omitZeroMinute: true,
                meridiem: 'short'
              },
            }
          },
          /* Choose view when initialize */
          initialView: mobileDeviceCheck() ? "newView" : "timeGridWeek",
          /* Check if window resize and add the new view */
          windowResize: function(view) {
            if (window.innerWidth >= 768 ) {
              calendar.changeView('timeGridWeek');
              /* More code */
            } else {
              calendar.changeView('newView');
              /* More code */
            }
          },

          contentHeight: mobileDeviceCheck() ? 500 : undefined,
          stickyHeaderDates: true,

          headerToolbar: {
            left: 'prev',
            center: 'title',
            right: 'next'
          },

          dayHeaderContent: function(arg) {
            let day = moment(arg.date).utc().format('ddd');
            let date = moment(arg.date).utc().format('D MMM');
            let spanEl = document.createElement('span');
            spanEl.innerHTML = `${day} <br> ${date}`;
            let arrayOfDomNodes = [ spanEl ];
            return { domNodes: arrayOfDomNodes };
          },

          datesSet: function(info) {
            if (!$('.timezone-info').length) {
              var timezoneOffset = calendarEl.dataset.timezoneOffset;
              if (timezoneOffset === undefined || timezoneOffset === null || timezoneOffset === 'undefined') {
                timezoneOffset = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
              }

              var timezoneLabel = (typeof I18n !== 'undefined' && I18n.t) ? I18n.t('javascript.schedule.times_in_local_timezone') : 'Times are shown in your local time zone';
              $(".fc-toolbar-chunk:nth-child(2)").append(`<div class="timezone-info text-center"><strong>${timezoneLabel}</strong></div><div class="timezone-offset text-center"><strong>(${timezoneOffset} GMT)</strong></div>`);
            }

            $('.fc-header-toolbar').addClass('text-center');

            if (popupEl != undefined) {
              $(popupEl).popover('hide');
            }
          },

          now: now,
          firstDay: firstDay,
          timeZone: timeZone,
          slotMinTime: '05:00',
          locale: fcLocale || 'en',
          displayEventTime: false,
          selectable: true,
          eventClassNames: function(info) {
            var eventType = `${info.event.extendedProps.event_type}`;

            if (eventType === 'booked') {
              return ['booked'];
            }
          },
          eventMouseEnter: function(info) {
            var highlightedEvent = info.event;
            var lessonTime = momentTimezone.tz(highlightedEvent.extendedProps.start_datetime, timeZone).format('hh:mm A');
            var eventType = `${highlightedEvent.extendedProps.event_type}`;

            if (eventType != 'unavailable' && eventType != 'booked') {
              var eventId = highlightedEvent.id;
              var adjacentEventId = findAdjacentEventId(eventId);
              var previousEventId = findPreviousEventId(eventId);

              if (lessonDuration === defaultLessonDuration) {
                //TODO: This is ugly. Replace with event object check. Event object contains an array of event ids
                if (((adjacentEventId != null) && (selectedEvents[eventId] === undefined) && (adjacentEvents[eventId] === undefined) && (selectedEvents[adjacentEventId] === undefined) && (adjacentEvents[adjacentEventId] === undefined)) || ((previousEventId != null) && (selectedEvents[previousEventId] === undefined) && (adjacentEvents[eventId] === undefined) && (selectedEvents[previousEventId] === undefined) && (adjacentEvents[previousEventId] === undefined))) {
                  var adjacentEvent = findAdjacentEvent(eventId);
                  var previousEvent = findPreviousEvent(eventId);

                  // ignore hover if for 60 minute lesson where adjacent event is midnight and previous event is unavailable
                  if ((lessonDuration === defaultLessonDuration) && isMidnight(adjacentEvent) && (previousEvent === null)) {
                    return;
                  }

                  if (adjacentEvent != null) {
                    if ((adjacentEvent.extendedProps.event_type === 'unavailable') || adjacentEvent.extendedProps.event_type === 'booked') {
                      return;
                    }
                  }

                  // ignore hover if 60 minute lesson with no adjacent event
                  if (lessonDuration === defaultLessonDuration) {
                    if ((adjacentEvent != null) && (selectedEvents[adjacentEventId] === undefined) && (adjacentEvents[adjacentEventId] === undefined) && !isMidnight(adjacentEvent)) {
                      highlightedEvent.setProp('backgroundColor', '#3D4752');
                      adjacentEvent.setProp('backgroundColor', '#3D4752');
                      //} else if ((previousEventId != null) && (selectedEvents[eventId] === undefined) && (selectedEvents[previousEventId] === undefined)) {
                    } else if ((previousEventId != null) && (selectedEvents[eventId] === undefined)) {
                      highlightedEvent.setProp('backgroundColor', '#3D4752');
                      previousEvent.setProp('backgroundColor', '#3D4752');
                    }

                    if (adjacentEvent != null || previousEvent != null) {
                      if (popupEnabled()) {
                        if (popupEl != undefined) {
                          $(popupEl).popover('hide');
                        }
                        if (!$('.popover').length) {

                          if (selectedEvents[adjacentEventId] != undefined) {
                            $(info.el).popover('dispose');
                            var popoverContent = buildPopoverContent(highlightedEvent);

                            setupPopover(info.el, 'title', popoverContent);;
                          }

                          // show popover
                          $(info.el).popover('show');
                          popupEl = info.el;
                        }
                      }
                    }
                  }
                }
              } else {
                highlightedEvent.setProp('title', lessonTime);
                highlightedEvent.setProp('backgroundColor', '#3D4752');
              }
            }
          },
          eventMouseLeave: function(info) {
            var eventType = `${info.event.extendedProps.event_type}`;

            if (eventType != 'unavailable' && eventType != 'booked') {

              if (popupEnabled()) {
                if (!$('.popover:hover').length) {
                  // hide popover
                  $(info.el).popover('hide');
                  popupEl = undefined;
                }
              }

              if (lessonDuration === defaultLessonDuration) {
                var highlightedEvent = info.event;
                var adjacentEvent = findAdjacentEvent(highlightedEvent.id);
                var adjacentEventId = findAdjacentEventId(highlightedEvent.id);
                var previousEvent = findPreviousEvent(highlightedEvent.id);
                var previousEventId = findPreviousEventId(highlightedEvent.id);

                // ignore if highlighted event is selected event or adjacent event
                if ((selectedEvents[highlightedEvent.id] != undefined) || (adjacentEvents[highlightedEvent.id] != undefined)) {
                  return;
                }

                // ignore hover if for 60 minute lesson where adjacent event is midnight and previous event is unavailable
                if ((lessonDuration === defaultLessonDuration) && isMidnight(adjacentEvent) && (previousEvent === null)) {
                  return;
                }

                if (adjacentEvent != null) {
                  if ((adjacentEvent.extendedProps.event_type === 'unavailable') || adjacentEvent.extendedProps.event_type === 'booked') {
                    return;
                  }
                }

                if ((selectedEvents[highlightedEvent.id] === undefined) && ((adjacentEvent != null) && !isMidnight(adjacentEvent)) && (selectedEvents[adjacentEventId] === undefined) && (adjacentEvents[adjacentEventId] === undefined)) {
                  adjacentEvent.setProp('backgroundColor', '#1ABC9C');
                  highlightedEvent.setProp('backgroundColor', '#1ABC9C');
                  adjacentEvent.setProp('title', '');
                } else if ((selectedEvents[highlightedEvent.id] === undefined) && (previousEvent != null) && (selectedEvents[previousEventId] === undefined) && (adjacentEvents[previousEventId] === undefined)) {
                  previousEvent.setProp('backgroundColor', '#1ABC9C');
                  highlightedEvent.setProp('backgroundColor', '#1ABC9C');
                  previousEvent.setProp('title', '');
                } else {
                  if ((adjacentEvent != null) && (selectedEvents[adjacentEventId] === undefined)) {
                    adjacentEvent.setProp('backgroundColor', '#3D4752');
                    highlightedEvent.setProp('backgroundColor', '#3D4752');
                    adjacentEvent.setProp('title', '');
                  }
                }
              } else {
                var highlightedEvent = info.event;

                // ignore if highlighted event is selected event
                if (selectedEvents[highlightedEvent.id] != undefined) {
                  return;
                }

                highlightedEvent.setProp('backgroundColor', '#1ABC9C');
                highlightedEvent.setProp('title', '');
              }
            }
          },
          defaultTimedEventDuration: '00:30',
          allDaySlot: false,
          slotLabelFormat: {
            hour: 'numeric',
            minute: '2-digit'
          },
          editable: false,
          selectable: false,
          eventDidMount: function(info) {
            var popoverTitle;
            var popoverContent;
            var title;
            var selectedEvent = info.event;
            var studentName = `${selectedEvent.extendedProps.student_name}`;
            var tutorName = `${selectedEvent.extendedProps.tutor_name}`;
            var language = `${selectedEvent.extendedProps.language}`;
            var eventType = `${selectedEvent.extendedProps.event_type}`;

            // add book lesson button if calendar type not present
            if (studentName === undefined || studentName === null) {
              popoverTitle = `<div class="avatar-w"><img height="50px" class="rounded-circle mr-2" src=${calendarEl.dataset.tutorProfilePhotoUrl}></img><span>${tutorName}</span></div>`;
            } else {
              popoverTitle = `<span>${studentName}</span></div>`;
            }

            popoverContent = buildPopoverContent(selectedEvent);

            setupPopover(info.el, popoverTitle, popoverContent);


            if (eventIds.length > 0) {
              if (eventIds.includes(selectedEvent.id)) {
                if (eventType == 'unavailable' || eventType == 'booked') {
                  let index = eventIds.indexOf(selectedEvent.id);
                  eventIds.splice(index, 1);
                  lessonTimes.splice(index, 1);
                  return;
                } else {
                  if (lessonDuration === defaultLessonDuration) {
                    let adjacentEvent = findAdjacentEvent(selectedEvent.id);
                    if (adjacentEvent != null) {
                      // hacky way to get event to set props
                      // https://github.com/fullcalendar/fullcalendar/issues/5916
                      setTimeout(function() {
                        selectedEvent.setProp('backgroundColor', '#3D4752');
                        selectedEvent.setProp('classNames', ['selected']);
                        adjacentEvent.setProp('backgroundColor', '#3D4752');
                        adjacentEvent.setProp('classNames', ['selected']);
                      });
                    }
                  } else {
                    setTimeout(function() {
                      selectedEvent.setProp('backgroundColor', '#3D4752');
                      selectedEvent.setProp('classNames', ['selected']);
                    });
                  }

                  let index = eventIds.indexOf(selectedEvent.id);
                  eventIds.splice(index, 1);
                  lessonTimes.splice(index, 1);
                }
              }
            } else {
              if (eventType != 'unavailable' && eventType != 'booked') {
                if ((selectedEvents[selectedEvent.id] != undefined) || (adjacentEvents[selectedEvent.id] != undefined)) {
                  setTimeout(function() {
                    selectedEvent.setProp('backgroundColor', '#3D4752');
                    selectedEvent.setProp('classNames', ['selected']);
                  });
                }
              }
            }
          },
          eventClick: function(info) {
            var lessonTime = momentTimezone.tz(info.event.extendedProps.start_datetime, timeZone).format();
            var eventsLength = Object.keys(selectedEvents).length;
            var eventId = info.event.id;
            var selectedEvent = info.event;
            var eventType = `${selectedEvent.extendedProps.event_type}`;

            if (eventType == 'unavailable' || eventType == 'booked') {
              return;
            }

            if (lessonDuration === defaultLessonDuration) {
              var prevEventId = parseInt(info.event.id) - 1800;
              var nextEventId = parseInt(info.event.id) + 1800;

              var adjacentEvent = findAdjacentEvent(selectedEvent.id);
              var previousEvent = findPreviousEvent(selectedEvent.id);

              if ((lessonDuration === defaultLessonDuration) && isMidnight(adjacentEvent) && (previousEvent === null)) {
                return;
              }

              if (adjacentEvent != null) {
                if ((adjacentEvent.extendedProps.event_type === 'unavailable') || adjacentEvent.extendedProps.event_type === 'booked') {
                  return;
                }
              }

              if ((eventsLength != lessonsCount) &&
                (((adjacentEvent != undefined) &&
                  (selectedEvents[eventId] === undefined) &&
                  ((selectedEvents[prevEventId] === undefined) && (adjacentEvents[prevEventId] === undefined) || (selectedEvents[prevEventId] === undefined) && (adjacentEvents[prevEventId] != undefined)) &&
                  (adjacentEvents[eventId] === undefined) &&
                  (adjacentEvents[nextEventId] === undefined) &&
                  (selectedEvents[nextEventId] === undefined)) ||
                  ((previousEvent != undefined) &&
                    (selectedEvents[eventId] === undefined) &&
                    ((selectedEvents[prevEventId] === undefined) && (adjacentEvents[prevEventId] === undefined) || (selectedEvents[prevEventId] === undefined) && (adjacentEvents[prevEventId] != undefined)) &&
                    (adjacentEvents[eventId] === undefined) &&
                    (adjacentEvents[prevEventId] === undefined) &&
                    (selectedEvents[prevEventId] === undefined)))
              ) {


                if ((adjacentEvent != null) && (previousEvent != null) && isMidnight(adjacentEvent)) {
                  // clicked last available slot, so add lesson to previous slot and available slot
                  addLesson(previousEvent, selectedEvent);
                } else if ((adjacentEvent != null) && (selectedEvents[findAdjacentEventId(eventId)] === undefined)) {
                  addLesson(selectedEvent, adjacentEvent);
                } else if (previousEvent != null) {
                  addLesson(previousEvent, selectedEvent);
                }

                updateLessonsCount();
                eventsLength = Object.keys(selectedEvents).length;

                selectedEvent.setProp('backgroundColor', '#3D4752');
                selectedEvent.setProp('classNames', ['selected']);

                if ((adjacentEvent != null) && (selectedEvents[findAdjacentEventId(eventId)] === undefined) && !isMidnight(adjacentEvent)) {
                  adjacentEvent.setProp('backgroundColor', '#3D4752');
                  adjacentEvent.setProp('classNames', ['selected']);

                  selectedEvent.setProp('title', momentTimezone.tz(selectedEvent.extendedProps.start_datetime, timeZone).format('hh:mm A'));
                } else if (previousEvent != null) {
                  previousEvent.setProp('backgroundColor', '#3D4752');
                  previousEvent.setProp('classNames', ['selected']);

                  selectedEvent.setProp('title', momentTimezone.tz(previousEvent.extendedProps.start_datetime, timeZone).format('hh:mm A'));
                }

                updateStartTimes();

                if (popupEnabled()) {
                  $(popupEl).popover('hide');
                }

                if (eventsLength === 1) {
                  // check recurring availability
                  if (displayRecurringAvailability()) {
                    fetchRecurringAvailability(selectedEvent.extendedProps.start_datetime);
                  } else {
                    enableSubmitButton();
                  }
                }

                selectedEvent.setProp('title', '');
              } else {

                // remove lesson if already selected
                // if previous event is primary selected event
                if ((previousEvent != null) && (selectedEvents[eventId] === undefined) && (selectedEvents[prevEventId] != undefined) && (adjacentEvents[eventId] != undefined)) {
                  // remove previous event
                  deleteLesson(prevEventId);

                  updateLessonsCount();
                  updateStartTimes();
                } else if ((selectedEvents[eventId] != undefined) && (previousEvent != undefined) && isMidnight(adjacentEvent)) {
                  // de-selected last time slot
                  deleteLesson(eventId);
                  previousEvent.setProp('backgroundColor', '#1ABC9C');

                  updateLessonsCount();
                  updateStartTimes();
                } else if (selectedEvents[eventId] != undefined) {
                  // else remove highlighted event
                  deleteLesson(eventId);

                  updateLessonsCount();
                  updateStartTimes();
                }
              }
            } else {
              if ((eventsLength != lessonsCount) && (selectedEvents[eventId] === undefined)) {
                addLesson(selectedEvent, null);

                updateLessonsCount();
                eventsLength = Object.keys(selectedEvents).length;
                updateStartTimes();

                selectedEvent.setProp('backgroundColor', '#3D4752');
                selectedEvent.setProp('classNames', ['selected']);
                selectedEvent.setProp('title', momentTimezone.tz(selectedEvent.extendedProps.start_datetime, timeZone).format('hh:mm A'));

                if (eventsLength === 1) {
                  if (displayRecurringAvailability()) {
                    fetchRecurringAvailability(selectedEvent.extendedProps.start_datetime);
                  } else {
                    enableSubmitButton();
                  }
                }
              } else {
                // remove lesson if already selected
                deleteLesson(eventId);

                setTimeout(function() {
                  selectedEvent.setProp('backgroundColor', '#1ABC9C');
                  selectedEvent.setProp('title', '');
                });

                updateLessonsCount();
                updateStartTimes();
              }
            }
          }
        });

        var fetchRecurringAvailability = function(startDate) {
          const tutorId = calendarEl.dataset.id;
          let eventsLength = Object.keys(selectedEvents).length;
          let remainingLessons = lessonsCount - eventsLength;

          if (remainingLessons > 0) {
            let endDate = moment(startDate).add(90, 'day').format('YYYY-MM-DD');
            //let eventsUrl = '/schedule/' + calendarEl.dataset.id + `?calendar_type=${calendarType}&step=${calendarStep}&start=${info.start}&end=${info.end}`;
            let recurringUrl = '/account/recurring_availability/' + calendarEl.dataset.id + `?calendar_type=${calendarType}&step=${calendarStep}&start=${startDate}&end=${endDate}&duration=${lessonDuration}&remaining_lessons=${remainingLessons}`;
            if (timeZone != undefined && timeZone != 'local') {
              recurringUrl = encodeURI(`${recurringUrl}&time_zone=${encodeURIComponent(timeZone)}`);
            }


            fetch(recurringUrl, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' }
            }).then(response => response.json()).then(data => {

              let availableRecurringDates = data.dates;
              let numOfWeeks = availableRecurringDates.length;

              if (numOfWeeks > 0) {
                let modalEl = '#recurring-modal';
                let displayRecurringDateEl = document.getElementById('display-recurring-date');
                let recurringDatesEl = document.getElementById('display-recurring-dates');

                // create selected recurring dates object with all recurring dates
                let selectedRecurringDates = {};
                for (let i = 0; i < numOfWeeks; i++) {
                  let event = availableRecurringDates[i];
                  selectedRecurringDates[event.id] = event.start;
                }

                // set recurring header message
                displayRecurringDateEl.innerHTML = I18n.t('javascript.schedule.recurring_booking_message', { date_time: momentTimezone.tz(startDate, timeZone).format('MMMM D (dddd), h:mm A') });

                // set recurring dates
                availableRecurringDates.forEach(function(event) {
                  let div = document.createElement('div');
                  div.id = `${event.id}`;
                  div.className = 'recurring-date mt-3';
                  div.innerHTML = `<span class="d-inline-block">${momentTimezone.tz(event.start, timeZone).format('MMMM D (dddd), h:mm A')}</span> <a id="trash-recurring-${event.id}" class="ml-3 float-right" data-id="${event.id}" href="javascript:void(0)"> <i class="ti-trash"></i></a>`;
                  recurringDatesEl.appendChild(div);
                });

                // setup trash button for recurring dates
                var trashButtons = document.getElementById('display-recurring-dates');
                trashButtons.addEventListener('click', (e) => {
                  if(e.target.className == 'ti-trash') {
                    var eventId = e.target.parentNode.dataset.id;
                    delete selectedRecurringDates[eventId];

                    let remove = document.getElementById(eventId);
                    let parentNode = remove.parentNode;
                    parentNode.removeChild(remove);

                    if (Object.keys(selectedRecurringDates).length === 0) {
                      $(modalEl).modal('hide');
                      recurringBookingEnabled = false;
                    }
                  }
                });

                // setup submit button
                let submitButton = document.getElementById('submit-recurring-availability');
                submitButton.addEventListener('click', (e) => {

                  let selectedEventIds = Object.keys(selectedEvents);
                  let startTimes = Object.values(selectedEvents).map(x => momentTimezone.tz(x[0].extendedProps.start_datetime, timeZone).toISOString());

                  // Dedup lesson times
                  startTimes = Array.from(new Set(startTimes));
                  selectedEventIds = Array.from(new Set(selectedEventIds));

                  // add each date to lesson times
                  Object.keys(selectedRecurringDates).forEach(eventId => {
                    startTimes.push(momentTimezone.tz(selectedRecurringDates[eventId], timeZone).toISOString());
                    selectedEventIds.push(eventId);
                  })

                  // update start times hidden field
                  document.getElementById('schedule_lesson_form_start_times').value = JSON.stringify(startTimes);
                  document.getElementById('schedule_lesson_form_event_ids').value = JSON.stringify(selectedEventIds);
                  document.getElementById('schedule_lesson_form_events').value = JSON.stringify(selectedEvents);
                  document.getElementById('schedule_lesson_form_adjacent_events').value = JSON.stringify(adjacentEvents);

                  // enable submit button
                  confirmBtn.disabled = false;

                  // submit form
                  confirmBtn.click();
                });

                // on modal close disable recurring booking
                $(modalEl).on('hidden.bs.modal', function () {
                  // clean up recurring dates
                  recurringDatesEl.innerHTML = '';
                  selectedRecurringDates = {};
                  recurringBookingEnabled = false;

                  // enable submit button
                  enableSubmitButton();
                });

                $(modalEl).modal('show');

              } else {
                // enable submit button
                enableSubmitButton();
              }
            });
          }
        }

        calendar.render();

        if (selectedEvents != {}) {
          updateLessonsCount();
          updateStartTimes();
        }

      });
    });
  }
});
